export const MODEL_ROUTE = '/locations';
